export const addStep = step => async dispatch => {
  dispatch({
    type: 'ADD_STEP',
    step,
  });
};

export const clearStep = step => async dispatch => {
  dispatch({
    type: 'CLEAR_STEP',
    step,
  });
};

export const popStep = () => async dispatch => {
  dispatch({
    type: 'POP_STEP',
  });
};
